export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const POSTHOG_ENABLED = IS_PRODUCTION || process.env.NEXT_PUBLIC_FORCE_ANALYTICS === 'true';

const RAW_DEPLOY_ENV = process.env.NEXT_PUBLIC_DEPLOY_ENV;
export const DEPLOY_ENV: 'development' | 'production' =
  RAW_DEPLOY_ENV === 'prod' || RAW_DEPLOY_ENV === 'production' ? 'production' : 'development';
export const IS_DEPLOY_PRODUCTION = DEPLOY_ENV === 'production';

export const POSTHOG_HOST = 'https://us.i.posthog.com';

export const BASE_URL = 'https://bazak.ai';
export const PRODUCT_NAME = 'Bazak Bridge';
export const COMPANY_NAME = 'Bazak';
export const SUPPORT_EMAIL = 'support@bazak.ai';
export const PRIVACY_EMAIL = 'privacy@bazak.ai';
export const HTTP_STATUS = { NOT_FOUND: 404 } as const;

export const DEMO_URL = 'https://calendar.app.google/mWmsY7uZ38ipdeXd7';

export const LEGAL_LAST_UPDATED_ISO = '2026-05-08';
export const LEGAL_LAST_UPDATED_LABEL = 'May 8, 2026';

export const LEGAL_ROUTES = {
  privacyNotice: '/privacy-notice',
  cookieNotice: '/cookie-notice',
  doNotSell: '/do-not-sell',
  termsOfUse: '/terms-of-use',
} as const;
